import { RouterType } from '@online-webinar/router';
import { EditSurveyPage } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/edit-survey'].update({
        staticData: { title: { page: 'EditSurvey.Pageheading', forWebinar: true } },
        component: authGuard(EditSurveyPage, { canBroadcast: true })
    });
};
